(ns dashboard.views.workbook-workspace.view
  (:require ["react" :as react]
            [dashboard.entity.question.db :as question.db]
            [dashboard.entity.questionnaire.db :as questionnaire.db]
            [dashboard.views.workbook-workspace.components.browser :refer [browser]]
            [dashboard.views.workbook-workspace.components.context-menu :refer [context-menu]]
            [dashboard.views.workbook-workspace.components.grid :refer [grid]]
            [dashboard.views.workbook-workspace.events :as events]
            [dashboard.views.workbook-workspace.subs :as subs]
            [re-frame.core :as rf]))

(def controllers [{:start (fn [_]
                            (rf/dispatch [::events/workbook-workspace.browser.fetch-workbooks]))}])

(defn workbook-workspace []
  ;; Note: Apparently, in "calc(100vh - 4.5rem)" the 4.5rem comes from:
  ;; dashboard/sass/repliance.scss
  ;; margin-top: 4.5rem;
  ;; Would need to clean up the whole view
  (let [common-props {:panel-max-height "calc(100vh - 3.5rem)"}]
    [:div.is-flex.is-flex-direction-column
     {:style {:min-height "calc(100vh - 52px)" :flex "1"}}
     ;; Panels
     [:div.columns.m-0.is-flex-grow-1
      [browser common-props]
      [grid    common-props]]
     [:f> context-menu]]))

(defn workbook-modal
  [{{:keys [questionnaire-id filename]} :ctx}]
  (let [state @(rf/subscribe [::subs/workbook-workspace.state])
        [loaded set-loaded] (react/useState (and (= (-> state :browser :path second :questionnaire) questionnaire-id)
                                                 (-> state :browser :path count (>= 2))))
        on-save-callback #(do
                            (question.db/get-sections questionnaire-id)
                            (questionnaire.db/get-questions questionnaire-id nil))]
    (react/useEffect
     (fn []
       (when-not loaded (rf/dispatch [::events/workbook-workspace.browser.fetch-workbooks]))
       (fn []))
     #js [])
    (react/useEffect
     (fn []
       (when (or (-> state :browser :path count (= 1))
                  (not loaded)
                  (not= (-> state :browser :path second :questionnaire) questionnaire-id))
         (set-loaded true)
         (rf/dispatch [::events/workbook-workspace.browser.force-path-for-modal
                       [{:path-type :root, :title "Workbooks"}
                        {:path-type :workbook, :filename filename, :questionnaire questionnaire-id}]]))
       (fn [])
       (array state)))
    [:div
     [:div {:style {:min-width "95vw" :display "flex" :flex "1"}}
     (let [common-props {:panel-max-height "calc(90vh)"
                         :on-save on-save-callback}]
       [:div.is-flex.is-flex-direction-column
        {:style {:min-height "calc(100vh - 52px)" :flex "1"}}
        ;; Panels
        [:div.columns.m-0.is-flex-grow-1
         {:style {:max-width "90vw"
                  :background-color "#fff"}}
         [browser common-props]
         [grid    common-props]]
        [:f> context-menu]])]]))
